import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

type CellDetailProps = {
  text: string;
};

const CellDetail = ({ text }: CellDetailProps) => {
  return (
    <Tooltip title={text}>
      <Typography variant="body2" noWrap>
        {text}
      </Typography>
    </Tooltip>
  );
};

export { CellDetail };
export type { CellDetailProps };
